import {
  Cushion,
  FlexContainer,
  Grid,
  MaxWidth,
  Rectangle,
  ShimmerImage,
  ShimmerTypography,
  Space,
} from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';

const NewsLoading = ({ isMobile }) => (
  <Rectangle fill="#fff" style={{ marginTop: '24px' }}>
    <MaxWidth maxWidth={1366} center>
      <Grid
        preset="newsListContainer"
        style={{ margin: isMobile ? '0' : '20px 0' }}
        component="div"
      >
        <div>
          <Space bottom="large">
            {isMobile ? (
              <FlexContainer flexDirection="column">
                <ShimmerImage preset="card" fullWidth />
                <FlexContainer
                  flexDirection="column"
                  style={{ gap: '10px', padding: '10px', backgroundColor: 'grey' }}
                >
                  <ShimmerTypography width="90%" height="32px" />
                  <ShimmerTypography width="70%" height="16px" />
                  <ShimmerTypography width="70%" height="16px" />
                </FlexContainer>
              </FlexContainer>
            ) : (
              <ShimmerImage preset="card" style={{ borderRadius: '10px' }} fullWidth />
            )}
          </Space>
          <Cushion horizontal={isMobile ? '10px' : '0'}>
            <Grid preset="newsList">
              {Array(4)
                .fill(1)
                .map(() => (
                  <FlexContainer flexDirection="column" style={{ gap: '10px' }}>
                    <ShimmerImage preset="card" style={{ borderRadius: '10px' }} fullWidth />
                    <ShimmerTypography width="90%" height="32px" />
                    <ShimmerTypography width="75%" height="16px" />
                    <ShimmerTypography width="66%" height="16px" />
                  </FlexContainer>
                ))}
            </Grid>
          </Cushion>
        </div>
      </Grid>
    </MaxWidth>
  </Rectangle>
);

NewsLoading.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

export default NewsLoading;
